import React from 'react'
import { listAffiliateLeads } from '../services/affiliateLeadService'
import type { AffiliateLead } from '../types'

export function useAffiliateLeads() {
  const [items, setItems] = React.useState<AffiliateLead[]>([])
  const [total, setTotal] = React.useState(0)
  const [page, setPage] = React.useState(1)
  const pageSize = 25
  const [search, setSearch] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const { items, total } = await listAffiliateLeads({ search, page, pageSize })
      setItems(items)
      setTotal(total)
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao carregar interessados')
    } finally {
      setLoading(false)
    }
  }, [search, page, pageSize])

  React.useEffect(() => {
    load()
  }, [load])

  return {
    items,
    total,
    page,
    setPage,
    pageSize,
    search,
    setSearch,
    loading,
    error,
    load,
  }
}

